module.exports = __webpack_public_path__ + "static/img/iconThree.da8d4312.svg";